"use strict";
/**
 * Purely presentational layer — takes ALREADY-ROUNDED decimal strings produced by
 * `@normax-performance/calculation-engine` (policies/v1/rounding.ts) and applies
 * Serbian locale conventions (comma decimal separator, explicit +/- sign). This
 * module performs NO rounding/arithmetic of its own (CALCULATION_ENGINE_ARCHITECTURE.md §7).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.dotToCommaDecimal = dotToCommaDecimal;
exports.signedCommaDecimal = signedCommaDecimal;
exports.formatQuantityLabel = formatQuantityLabel;
exports.formatPerformanceRatioLabel = formatPerformanceRatioLabel;
exports.formatDeviationPercentLabel = formatDeviationPercentLabel;
exports.formatDeviationPointsLabel = formatDeviationPointsLabel;
exports.formatDeviationPointsCompactLabel = formatDeviationPointsCompactLabel;
exports.formatMinutesLabel = formatMinutesLabel;
exports.formatNormedMinutesLabel = formatNormedMinutesLabel;
/** "42.22" -> "42,22". Does not touch sign or add a % suffix. */
function dotToCommaDecimal(value) {
    return value.replace(".", ",");
}
/** "6.58" -> "+6,58"; "-10.00" -> "-10,00"; "0.00" -> "0,00" (no sign on zero). */
function signedCommaDecimal(value) {
    const isNegative = value.trim().startsWith("-");
    const isZero = Number(value) === 0;
    const comma = dotToCommaDecimal(value.replace("-", ""));
    if (isZero)
        return comma;
    return isNegative ? `-${comma}` : `+${comma}`;
}
function formatQuantityLabel(roundedDotString) {
    if (roundedDotString === null)
        return null;
    return dotToCommaDecimal(roundedDotString);
}
/** roundedDotString is percentage-scale (e.g. "106.58" for 106.58%), unsigned. */
function formatPerformanceRatioLabel(roundedDotString) {
    if (roundedDotString === null)
        return null;
    return `${dotToCommaDecimal(roundedDotString)}%`;
}
/** roundedDotString is percentage-scale deviation (e.g. "6.58" or "-10.00"), signed. */
function formatDeviationPercentLabel(roundedDotString) {
    if (roundedDotString === null)
        return null;
    return `${signedCommaDecimal(roundedDotString)}%`;
}
/** Full-word variant for summary areas: "+6,58 procentnih poena". */
function formatDeviationPointsLabel(roundedDotString) {
    if (roundedDotString === null)
        return null;
    return `${signedCommaDecimal(roundedDotString)} procentnih poena`;
}
/** Compact variant for summary areas: "+19,62 p.p.". */
function formatDeviationPointsCompactLabel(roundedDotString) {
    if (roundedDotString === null)
        return null;
    return `${signedCommaDecimal(roundedDotString)} p.p.`;
}
function formatMinutesLabel(roundedDotString) {
    return dotToCommaDecimal(roundedDotString);
}
function formatNormedMinutesLabel(roundedDotString) {
    return `${dotToCommaDecimal(roundedDotString)} normiranih minuta`;
}
//# sourceMappingURL=decimal-display.js.map